import React from 'react';
import PT from 'prop-types';
import cIf from 'classnames';
import { noop } from 'lodash';

export function Icon({ className, tooltip, label, onClick })  {
    return <i className={cIf(["icon", className])} title={tooltip} aria-hidden="true" onClick={onClick != undefined ? onClick : noop}>{label}</i>;
}
Icon.propTypes = {
    className: PT.string,
    label: PT.string,
    tooltip: PT.string,
    onClick: PT.func
};
